import type { SuperEnhancementResponseDto } from 'app/API/models';

export const retainSuperEnhancementPreview = (
  previous: SuperEnhancementResponseDto | undefined,
  incoming: SuperEnhancementResponseDto,
): SuperEnhancementResponseDto => {
  if (
    previous?.status !== 'RUNNING' ||
    incoming.status !== 'RUNNING' ||
    !previous.runId ||
    previous.runId !== incoming.runId ||
    previous.revision === undefined ||
    !previous.utterances.length ||
    (incoming.revision !== undefined && incoming.revision >= previous.revision && incoming.utterances.length > 0)
  ) {
    return incoming;
  }
  return {
    ...incoming,
    revision: previous.revision,
    utterances: previous.utterances,
    sourceUtterances: previous.sourceUtterances,
  };
};
